import React from 'react'
import Card from '../nura/card/card'
import Modal from '../modal/modal'
import styles from './styles.module.css'
import BaseForm from "../base-form/base-form"
import Button from '../nura/button/button'

import { useDispatch, Actions } from '../../stores/dashboard.store'


export default ({ show }) => {
    const dispatch = useDispatch()

    const stay = () => dispatch(Actions.CloseUnsavedForm)
    const leave = () => dispatch(Actions.ForceNavigationUnsavedForm)

    return (
        <Modal show={show} style={{ minWidth: 358, height: 'auto', maxWidth: 800 }} onClose={stay}>
            <Card variant="modal" style={{ width: 350, height: 'auto' }}>
                <BaseForm onBack={stay} title="Unsaved Progress">
                    <div className={styles.menuDescription}>
                        <div>You are about to navigate away from your project, deleting all unsaved progress. Would you like to continue?</div>
                    </div>
                    <div className={styles.actionGroup}>                        
                        <Button style={{ width: '100%' }} variant="outline" onClick={stay}>Stay</Button>                        
                        <Button style={{ width: '100%' }} variant="error" onClick={leave}>Leave</Button>
                    </div>
                </BaseForm>
            </Card>
        </Modal>
    )
}